<template>
  <div class="container-fluid">
    <div class="d-flex justify-content-between pb-3 align-items-center">
      <div>
        <div class="h3 font-weight-bold my-0">
          {{ $t($route.name.toLowerCase().replace(/ /g, '_') + ".plural") }}
        </div>
        <div class="text-muted my-0">
          <span class="text-primary">Home</span> / Master Files / {{ $t($route.name.toLowerCase().replace(/ /g, '_') + ".plural") }}
        </div>
      </div>
      <div>
        <button
          class="btn2 btn2-primary btn2-md mr-1 mb-3 mb-sm-0"
          @click="$refs.createIndustry.show()"
          v-if="role_modules.some(item => item.value == 'industry.create')"
        >
          <i class="uil-plus mr-1"></i> {{ $t('industry.action.create_record') }}
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-xl-12">
      <!-- TO DO COMPUTED COMPONENTS FOR CREATE AND EDIT-->
      <Table
        ref="list"
        :useView="role_modules.some(item => item.value == 'industry.view')"
        :useEdit="role_modules.some(item => item.value == 'industry.edit')"
        :useDelete="role_modules.some(item => item.value == 'industry.delete')"
        :params="params"
        :noTitle="true"
        :fields="fields"
        :action="role_modules.some(item => item.value == 'industry') ? action : false"
        @openFormBar="openFormBar"
      />
      </div>
    </div>
    <Dialog
      centered
      title="View Industry"
      ref="viewIndustry"
      size="md"
      :component="viewComponent"
      :parameters="{ industryID, submitted }"
      v-if="role_modules.some(item => item.value == 'industry.view')"
    />
    <Dialog
      centered
      autoload
      is_reset_model
      title="Create Industry"
      ref="createIndustry"
      size="md"
      yesText="Create"
      noText="Cancel"
      :buttonDisable="created"
      :component="createComponent"
      @onYes="onCreateIndustry"
      v-if="role_modules.some(item => item.value == 'industry.create')"
    />
    <Dialog
      centered
      autoload
      title="Update Industry"
      ref="editIndustry"
      size="md"
      yesText="Update"
      noText="Cancel"
      :buttonDisable="updated"
      :component="editComponent"
      :parameters="{ industryID, submitted }"
      @onYes="onUpdateIndustry"
      v-if="role_modules.some(item => item.value == 'industry.edit')"
    />
    <Dialog
      centered
      autoload
      title="Delete Industry"
      ref="deleteIndustry"
      size="md"
      yesText="Delete"
      noText="Cancel"
      :buttonDisable="deleted"
      :component="deleteComponent"
      :parameters="{ id: industryID, submitted }"
      :module="'industry'"
      @onYes="onDeleteIndustry"
      v-if="role_modules.some(item => item.value == 'industry.delete')"
    />
  </div>
</template>

<script>
import Table from '@components/table'
import Dialog from '@components/offcanvas'
import moment from 'moment/moment'
import EditComponent from './components/dialogs/edit.vue'
import ViewComponent from './components/dialogs/view.vue'
import CreateComponent from './components/dialogs/create.vue'
import DeleteComponent from '@components/dialogs/delete.vue'

import error from '@utils/error'

export default {
  components: {
    Table,
    Dialog
  },
  computed: {
    editComponent() {
      return EditComponent
    },
    viewComponent () {
      return ViewComponent
    },
    createComponent() {
      return CreateComponent
    },
    deleteComponent() {
      return DeleteComponent
    }
  },
  data() {
    return {
      fields: [
				{ 
          label: this.$t('industry.table.name'), 
          key:"name",
          sortable: true
        },
        { 
          label: this.$t('industry.table.date_created'), 
          key:'date_created', 
          formatter: (val) => moment(val).format('YYYY-MM-DD')
        },
        {
          key:'actions',
          label:''
        }
      ],
      params: {},
      action: 'industry/pagination',
      industryID: '',
      submitted: false,
      created: false,
      updated: false,
      deleted: false,
    }
  },
  methods: {
    openFormBar(id, editMode = false, deleteMode = false) {
      this.industryID = id
      if (deleteMode) {
        this.$refs.deleteIndustry.show()
      } else if(!editMode){
        this.$refs.viewIndustry.show()
      } else {
        this.$refs.editIndustry.show()
      }
    },
    onCreateIndustry(val) {
      this.created = true;
      let model = val && val.model && Object.entries(val.model).length ? val.model : val

      val.validateForm && val.validateForm();
      if (val.$v && val.$v.$error) {
        this.created = false;
        return error.errorHandler({ message: "Required field(s) must not be empty" }, this.$bvToast)
      }

      return this.$store.dispatch('industry/create', { ...model })
      .then(res => {
        if (res && res.data) {
          this.$refs.list.fetchData();
          this.$refs.createIndustry.hide();
          this.$bvToast.toast('Industry successfully created!', {
            title: "Notification",
            variant: "success"
          })
          setTimeout(() => {
            this.created = false;
          }, 1500)
        }
      })
      .catch(err => {
        this.created = false;
        return error.errorHandler(err, this.$bvToast);
      })
    },
    onUpdateIndustry(val) {
      this.updated = true;
      let model = val && val.model && Object.entries(val.model).length ? val.model : val
      model.id = model._id ? model._id : model.id ? model.id : ''

      return this.$store.dispatch('industry/update', { ...model })
      .then(res => {
        if (res && res.data) {
          this.$refs.list.fetchData();
          this.$refs.editIndustry.hide();
          this.submitted = !this.submitted;
          this.$bvToast.toast(`Industry successfully updated!`, {
            title: "Notification",
            variant: 'success'
          })
          setTimeout(() => {
            this.updated = false;
          }, 1500)
        }
      })
      .catch(err => {
        this.updated = false;
        return error.errorHandler(err, this.$bvToast);
      })
    },
    onDeleteIndustry(val) {
      this.deleted = true;
      let id = val && val.model && val.model._id ? val.model._id : 
               val && val.model && val.model.id ? val.model.id :
               val && val.id ? val.id : 
               val && val._id ? val._id : 
               this.industryID;
      
      if (!id) {
        this.deleted = false;
        return;
      }

      return this.$store.dispatch('industry/delete', { id })
      .then(res => {
        if (res && res.data) {
          this.$refs.list.fetchData()
          this.$refs.deleteIndustry.hide()
          this.submitted = !this.submitted
          this.$bvToast.toast(`Industry successfully deleted!`, {
            title: "Notification",
            variant: 'success'
          })
          setTimeout(() => {
            this.deleted = false;
          }, 1500)
        }
      })
      .catch(err => {
        this.deleted = false;
        return error.errorHandler(err, this.$bvToast);
      })
    }
  }
}
</script>